import { render, staticRenderFns } from "./CreatePform.vue?vue&type=template&id=5bda5b8b"
import script from "./CreatePform.vue?vue&type=script&lang=js"
export * from "./CreatePform.vue?vue&type=script&lang=js"
import style0 from "./CreatePform.vue?vue&type=style&index=0&id=5bda5b8b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports